import { render, staticRenderFns } from "./tenderTrainContent.vue?vue&type=template&id=078959cc&scoped=true&"
import script from "./tenderTrainContent.vue?vue&type=script&lang=js&"
export * from "./tenderTrainContent.vue?vue&type=script&lang=js&"
import style0 from "./tenderTrainContent.vue?vue&type=style&index=0&id=078959cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078959cc",
  null
  
)

export default component.exports